import {type ApolloQueryResult} from '../state/graphql/apolloWithAbort';
export * from '@wandb/weave/common/components/Tags';

export type SaveTags = (tags: string[]) => Promise<ApolloQueryResult<{}>>;
